import { dollarsAndCents } from '.'

export const formatAmount = (amount: number, roundToNextDollar?: boolean) => {
  const { dollars, cents } = dollarsAndCents(amount)
  return roundToNextDollar && cents !== '00'
    ? `${parseInt(dollars, 10) + 1}.${'00'}`
    : `${dollars}.${cents}`
}
